import { SxProps } from '@mui/material';
import { Theme } from '@mui/system';
import { HelpOption, HelpOptions } from '../store/slices/help';

export const getHelpMessageCss = (
    helpOption: HelpOption,
    index: number,
): SxProps<Theme> => {

    switch (helpOption) {
    case HelpOptions.EXPLORE:
        switch (index) {
        default:
            return {};
        }
    case HelpOptions.SAVE_SPOTS:
        switch (index) {
        default:
            return {};
        }
    case HelpOptions.GROW_NETWORK:
        switch (index) {
        case 1:
        case 2:
            return {
                top: {
                    xs: '116px',
                    lg: 'unset'
                },
                bottom: {
                    xs: 'auto',
                    lg: '16px'
                }
            };
        default:
            return {};
        }
    }
};
